export function can(granted: string[], required: string): boolean {
  if (granted.includes('*')) return true;
  if (granted.includes(required)) return true;
  const [resource] = required.split(':');
  if (resource && granted.includes(`${resource}:*`)) return true;
  return false;
}
